import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetVouchersExportVoucherReportToExcelParams } from "api/api/vouchersApi/types";
import { VouchersAPI } from "api/api/vouchersApi/vouchersApi";
import axios from "axios";

export const getVouchersExportVoucherReportToExcel = createAsyncThunk<
  void,
  GetVouchersExportVoucherReportToExcelParams
>(
  `vouchers/getVouchersExportVoucherReportToExcel`,
  async ({ voucherId, ...params }, { rejectWithValue }) => {
    try {
      const data = await VouchersAPI.getVouchersExportVoucherReportToExcel({
        voucherId,
        ...params,
      });
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while getting vouchers export report to excel",
          error?.response?.data
        );
        return rejectWithValue(error?.response?.data || "Unknown error");
      } else {
        console.error("Error while getting vouchers export report to excel", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);
